import 'animate.css';
import { Store } from 'react-notifications-component';

export const showAlert = (type, text, options = {}) => {
  Store.addNotification({
    insert: "bottom",
    container: "bottom-center",
    message: text,
    type: type,
    animationIn: ["animate__animated", "animate__fadeIn"],
    animationOut: ["animate__animated", "animate__fadeOut"],
    dismiss: {
      duration: 8000,
    },
    ...options
  });
}